import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { PartnerService } from '../../../../../../services/partner.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-vend-defaults',
  templateUrl: './vend-defaults.component.html',
  styleUrls: ['./vend-defaults.component.scss'],
  providers: [MessageService],
})
export class VendDefaultsComponent implements OnInit {
  @Input() partner;
  @Output() status = new EventEmitter();
  public partnerID;
  public busy = true;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public users: any = [];
  public paymentTypes: any = [];
  public isWizard: boolean = false;
  public technicians: any = [];
  public busyTechnicians = false;
  public isWorkshop = true;
  public isRentals = false;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private partnerService: PartnerService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/pos-integrations'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }
    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getRegisters();
    this.getTaxes();
    this.getUsers();
    this.getPaymentTypes();
    this.getConfig();
    this.getTechnicians();
  }

  getTechnicians() {
    this.partnerService
      .getPartnerTechnicians(this.partnerID)
      .subscribe((technicians) => {
        this.technicians = technicians.filter((x) => {
          return x.IsActive === true;
        });
      });
  }

  getConfig() {
    this.posIntegrationService.getVendConfig(this.partnerID).subscribe(
      (res) => {
        this.config = res;
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  getRegisters() {
    this.posIntegrationService
      .getVendRegisters(this.partnerID)
      .subscribe((res) => {
        this.registers = res.map((x) => {
          return { label: x.Description, value: x.Data };
        });
      });
  }

  getTaxes() {
    this.posIntegrationService.getVendTaxes(this.partnerID).subscribe((res) => {
      this.taxes = res.map((x) => {
        return { label: x.Description, value: x.Data };
      });
    });
  }

  getUsers() {
    this.posIntegrationService.getVendUsers(this.partnerID).subscribe((res) => {
      this.users = res.map((x) => {
        return { label: x.Description, value: x.Data };
      });
    });
  }

  getPaymentTypes() {
    this.posIntegrationService
      .getVendPaymentTypes(this.partnerID)
      .subscribe((res) => {
        this.paymentTypes = res.map((x) => {
          return { label: x.Description, value: x.Data };
        });
      });
  }

  updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;
    this.posIntegrationService.updateVendConfig(this.config).subscribe(
      (result) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('onboarding.pos_settings_updated'),
        });
        this.busy = false;
        // this.posIntegrationService.startFullPOSSync(this.partnerID).subscribe(sync=>{},err=>{});
        // this.posIntegrationService.startPOSClientSync(this.partnerID).subscribe(sync=>{},err=>{});
        this.status.emit({ configurationSaved: true });
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  updateTechnicians() {
    this.busyTechnicians = true;
    this.partnerService
      .updateTechnicianPOSEmployee(
        this.partnerID,
        this.technicians.map((x) => {
          return { TechnicianID: x.ID, POSEmployeeID: x.POSEmployeeID };
        }),
      )
      .subscribe((result) => {
        this.busyTechnicians = false;
      });
  }
}
